<template>
  <Modal width="1020" v-model="show" :mask-closable="false"  :loading="loading">
      <div slot="header" class="modal-header">修改房源</div>
      <Form :model="formData" :label-width="85" :rules="formRules" ref="formValidate">
        <Row :gutter="16">
          <Col :span="8">
            <FormItem label="项目名称" prop="projectFid">
              <Select v-model="formData.projectFid" @on-change="changeProject">
                <Option value="">请选择</Option>
                  <Option v-for="item in projectList" :value="item.value" :key="item.value">{{item.text}}</Option>
              </Select>
            </FormItem>
          </Col>
          <Col :span="8" >
            <FormItem label="楼栋" prop="buildingId">
                <Select v-model="formData.buildingId" @on-change="changeBuilding">
                  <Option value="">{{ formData.projectFid===''? '请先选择项目':(buildingList.length!==0 ?'请选择':'暂无数据')}}</Option>
                  <Option v-for="item in buildingList" :value="item.value" :key="item.value">{{item.text}}</Option>
                </Select>
            </FormItem>
          </Col> 
          <Col :span="8">
            <FormItem label="楼层" prop="houseFloorNumber">
                <Select v-model="formData.houseFloorNumber">
                  <Option value="">{{ formData.buildingId===''? '请先选择楼栋':(floorList.length!==0 ?'请选择':'暂无数据')}}</Option>
                  <Option v-for="item in floorList" :value="item.value" :key="item.value">{{item.text}}</Option>
                </Select>
            </FormItem>
          </Col>
        </Row>
        <Row :gutter="16">
          <Col :span="8">
            <FormItem label="房源编号" prop="houseNumber">
                <Input v-model="formData.houseNumber" ></Input>
            </FormItem>
          </Col>
          <Col :span="8" >
            <FormItem label="房型名称" prop="houseTypeId">
                <Select v-model="formData.houseTypeId" >
                  <Option value="">{{ formData.projectFid===''? '请先选择项目':(buildingList.length!==0 ?'请选择':'暂无数据')}}</Option>
                    <Option v-for="item in houseTypeList" :value="item.value" :key="item.value">{{item.text}}</Option>
                </Select>
            </FormItem>
          </Col>
          <Col :span="8">
            <FormItem label="床类型" prop="houseBedType">
              <Select v-model="formData.houseBedType">
                <Option value="">请选择</Option>
                  <Option v-for="item in houseBedTypeEnums" :value="item.value" :key="item.value">{{item.text}}</Option>
              </Select>
            </FormItem>
          </Col>
        </Row>
        <Row :gutter="16">
          <Col :span="8">
            <FormItem label="装修风格" prop="houseDecorationstyle">
                <Select v-model="formData.houseDecorationstyle" >
                  <Option value="">请选择</Option>
                    <Option v-for="item in houseDecorationStyleEnums" :value="item.value" :key="item.value">{{item.text}}</Option>
                </Select>
            </FormItem>
          </Col>
          <Col :span="8">
            <FormItem label="面积" prop="houseArea">
              <Input v-model="formData.houseArea" :number="true">
              <span slot="append">㎡</span>
              </Input>
            </FormItem> 
          </Col>
          <Col :span="8">
          <FormItem label="朝向" prop="houseDirection">
            <Select v-model="formData.houseDirection">
                <Option value="">请选择</Option>
                <Option v-for="item in directionHouseEnums" :value="item.value" :key="item.value">{{item.text}}</Option>
            </Select>
        </FormItem>
        </Col>
        </Row>
        <Row :gutter="16">
          <Col :span="8">
            <FormItem class="date-picker" label="最晚签约日" prop="houseMaxsigndate">
              <DatePicker ref="houseMaxsigndate" type="date"  v-model="formData.houseMaxsigndate" @on-change="formData.houseMaxsigndate=$event" placeholder="yyyy-mm-dd" ></DatePicker>
            </FormItem> 
          </Col>
        <Col :span="8">
          <FormItem label="出租类型" prop="houseRentType">
            <Select v-model="formData.houseRentType" :disabled="true">
              <Option value="">请选择</Option>
                <Option v-for="item in houseRentTypeEnums" :value="item.value" :key="item.value">{{item.text}}</Option>
            </Select>
          </FormItem>
        </Col>
        <Col v-if="formData.houseRentType===0" :span="8" >
          <FormItem label="出租价格" prop="houseRentPrice">
            <Input v-model="formData.houseRentPrice" :number="true">
            <span slot="append">元／月</span>
            </Input>
          </FormItem>
        </Col>       
        <Col :span="8" v-if="formData.houseRentType===1">
           <Button type="primary" size="small" style="margin-top:5px" @click="addRoom">添加房间／床位</Button>
        </Col>
        </Row>
        <div v-if="formData.houseRentType===0&&show">
          <long-term-set-price ref="houseRentType0LongTermPrice"></long-term-set-price>
        </div>
          <!-- <Row :gutter="16">
              <Col v-if="formData.houseRentType===0" :span="8" >
                  <FormItem label="长租优惠价" prop="stockRentDiscontPrice">
                      <Input v-model="formData.stockRentDiscontPrice" :number="true">
                          <span slot="append">元／月</span>
                      </Input>
                  </FormItem>
              </Col> -->
              <!-- :options="dateOption"-->
              <!-- <Col v-if="formData.houseRentType===0" :span="8" >
                  <FormItem label="生效时间" prop="discountPriceDate">
                      <DatePicker class="block" type="daterange"  style="margin-right: 10px;width: 300px;" split-panels placeholder="生效时间" v-model="discountPriceDate" @on-change="getdiscountPriceDate"></DatePicker>
                  </FormItem>
              </Col>
          </Row> -->
         <Row :gutter="16" v-if="formData.houseRentType===0">
           <Col :span="8">
            <FormItem label="房间状态" prop="houseStockStatus">
              <Select v-model="formData.houseStockStatus">
                <Option value="">请选择</Option>
                  <Option v-for="item in stockStatusEnums" :value="item.value" :key="item.value">{{item.text}}</Option>
              </Select>
            </FormItem>
          </Col>
         </Row>
       <div v-if="formData.houseRentType===1&&show">
        <add-room-format v-for="(item,index) in subRoomList" :type="0" :stockData ="item" :isUpdate="isUpdate" :stockStatusEnums="stockStatusEnums" :directionHouseEnums="directionHouseEnums" :stockTypeEnums="stockTypeEnums" :ref="`iform${index}`"  v-if="iformDynamic[index].status === 1" style="flex:1" :index="index" :key="`iform${index}`" @delete-item="deleteItem" ></add-room-format>
        <add-room-format :isUpdate="isUpdate" :type="1" :stockStatusEnums="stockStatusEnums" :directionHouseEnums="directionHouseEnums" :stockTypeEnums="stockTypeEnums" :ref="`form${i}`" v-if="item.status === 1" style="flex:1" v-for = "(item,i) in formDynamic" :index="i" :key="`form${i}`" @delete-item="deleteItem"></add-room-format>
       </div>  
       <Row :gutter="16">
          <Col :span="8">
            <FormItem label="业主名称" prop="ownerId">
              <Select v-model="formData.ownerId" filterable>
                <Option value="">请选择</Option>
                <Option v-for="item in projectOwnerList" :value="item.fid" :key="item.fid">{{item.name}}</Option>
              </Select>
            </FormItem>
          </Col>
        </Row>
        <FormItem label="备注" prop="remark">
          <Input v-model="formData.remark" type="textarea" :rows="4" ></Input>
        </FormItem>
      </Form>

      <div slot="footer">
        <Button type="text" size="large" @click="handleCancel">取消</Button>
        <Button type="primary" size="large" @click="save" :loading="loading">
          <span v-if="!loading">保存</span>
          <span v-else>保存中...</span>
        </Button>
      </div>
    </Modal>
</template>
 
<script type="text/ecmascript-6">
import AddRoomFormat from './AddRoomFormat';
import LongTermSetPrice from './components/LongTermSetPrice';
import { getHouseType,  toEditHouse, updateHouse, getMaxsigndate,deleteSubRoomBed } from "api/house"
export default {
  props: {
    n: {
      type: Number,
      default: 0
    },
    stockFid:{
      type:String,
      default:''
    },
    projectList:{
      type:Array,
      default:[]
    },
    projectOwnerList:{
      type:Array,
      default(){
        return []
      }
    },
  },
  watch: {
		n() {
      // this.$refs['formValidate'].resetFields();
			this.loading = false
      this.show = true;
     // this.iformDynamic = []
      this.formDynamic = []
      this.index = -1

      toEditHouse(this.stockFid).then( res => {
          this.initData = res.data
          this.stockTypeEnums = res.data.stockTypeEnums
          this.houseBedTypeEnums = res.data.houseBedTypeEnums
          this.houseDecorationStyleEnums = res.data.houseDecorationStyleEnums
          this.houseRentTypeEnums = res.data.houseRentTypeEnums
          this.directionHouseEnums = res.data.directionHouseEnums
          this.stockStatusEnums = res.data.stockStatusEnums
          this.formData = res.data.houseVo

          this.$nextTick(() => {
              if( this.formData.houseRentType === 0) this.$refs.houseRentType0LongTermPrice.setDiscountPriceDtoList(this.formData.discountPriceDtoList)
          })
          
          if(!res.data.houseVo.discountBeginTime){
              this.discountPriceDate = ['','']
          } else {
              this.discountPriceDate = [res.data.houseVo.discountBeginTime,res.data.houseVo.discountEndTime]
          }
          this.subRoomList = res.data.houseVo.subRoomList
          let len = this.subRoomList.length
          this.iformDynamic = []
          for(let i = 0; i< len ;i++) {
            this.iformDynamic.push({
              index:i,
              status:1
            })
          }
        })
    }
  },
  components:{
    AddRoomFormat,
    LongTermSetPrice
  },
  data () {
    const validateDate = (rules,value,callback)=>{
      rules.type = typeof value === 'object' ? 'object':'string'
      if(!value){
        callback(new Error('请选择最大签约到期时间'));
      }
      callback();
    }
    const validateNum = (rule, value, callback) => {  
      if(!value || typeof value === 'string' || value <= 0){
        callback(new Error('请输入大于0的数字'));
      }
      callback();
    }
    return {
        dateOption: {
            disabledDate (date) {
                return date && date.valueOf() < Date.now() - 86400000;
            }
        },
      initData:null,
      type:0, // type=0 数据渲染出的组件， type =1 手动添加的房间
      isUpdate:true,
      index:-1,
      iformDynamic:[],
      formDynamic:[],
      roomCount:1,
      show:false,
      loading:false,
      houseMaxsigndate:'',
      // projectList:[],
      buildingList:[],
      houseTypeList:[],
      floorList:[],
      houseBedTypeEnums:[],
      houseDecorationStyleEnums:[],
      houseRentTypeEnums:[],
      directionHouseEnums:[],
      stockStatusEnums:[],
      stockTypeEnums:[],
      discountPriceDate: ['',''],
      formData: {    
        buildingId: "",
        houseArea: "",
        houseBedType: "",
        houseDecorationstyle: "",
        houseDirection: "",
        houseFloorNumber: "",
        houseMaxsigndate: "",
        houseNumber: "",
        houseRentPrice: "",
        houseRentType: "",
        houseStockStatus: "",
        houseTypeId: "",
        ownerId:'',
        projectFid: "",
        remark: "",
        stockFid: "",
        stockRentDiscontPrice:"",
        discountBeginTime:"",
        discountEndTime:"",
        subRoomList: [],
        discountPriceDtoList:[]
      },
      formRules:{
        projectFid:[{ required: true, type:'string', message:'请选择项目名称', trigger: 'change'}],
        buildingId:[{ required: true, type:'string', message:'请选择楼栋', trigger: 'change'}],
        houseFloorNumber:[{ required: true, type:'number', message:'请选择楼层', trigger: 'change'}],
        houseTypeId:[{ required: true, type:'string', message:'请选择房型名称', trigger: 'change'}],
        houseNumber:[{ required: true, type:'string', message:'请输入房源编号', trigger: 'blur'}],
        houseBedType:[{ required: true, type:'number', message:'请选择床类型', trigger: 'change'}],
        houseDecorationstyle:[{ required: true, type:'number', message:'请选择装修风格', trigger: 'change'}],
        // houseMaxsigndate: [{ required: true, validator: validateDate, trigger:'change'}],
        houseRentType:[{ required: true, type:'number',message:'请选出租类型',trigger: 'change'}],
        houseArea:[{ required: true, validator: validateNum, trigger: 'blur'}],
        houseDirection:[{ required: true, type:'number', message:'请选择朝向', trigger: 'change'}],
        houseRentPrice:[{ required: true, validator: validateNum, trigger: 'blur'}]
			},
    };
  },
  methods:{
    addRoom(){
      this.index++
      this.formDynamic.push({
        index:this.index,
        status:1
      })
    },
    getdiscountPriceDate(val){
      this.formData.discountBeginTime = val[0]
      this.formData.discountEndTime = val[1]
    },
    changeProject(value){
      if(!value){
        this.buildingList=[]
        this.floorList =[]
        this.houseTypeList=[]
        this.formData.houseMaxsigndate=""
        return
      }
      for (let [index, item] of this.projectList.entries()) {
        if (value === item.value) {       
          this.buildingList = this.projectList[index].children;
        }
      }
      getHouseType(value).then(res => {
        this.houseTypeList = res.data.houseTypeList
      })
      getMaxsigndate(value).then(res => {
        this.houseMaxsigndate = res.data
      })
    },
    changeBuilding(value){
      if(!value){
        this.floorList =[]
        return
      }
      for (let [index, item] of this.buildingList.entries()) {
        if (value === item.value) {       
          this.floorList = this.buildingList[index].children;
        }
      }    
    },
    changeLoading() {
      this.loading = false;
      this.$nextTick(() => {
          this.loading = true
      })
    },
    deleteItem(data){
      let index = data.index
      if(data.type===0 && data.stockFid) {
        deleteSubRoomBed({stockFid:data.stockFid}).then( res => {
          this.$Message.success('删除子房源成功')
          this.iformDynamic[index].status = 0
          console.log(this.iformDynamic[index].status)
        })
      }else {
        this.formDynamic[index].status = 0
      }
      
    },
    getDateExp(ref) {
      if(typeof this.formData[ref]==='object'){
        this.formData[ref] = this.$refs[ref].publicStringValue
      }
    },
    handleCancel(){
      this.show = false
    },
    initSockInfo(){

    },
    validateSubRoomList(){
     // console.log('start')
      let formList = this.formDynamic.filter( item => {
        return item.status === 1
      }) 
      let iformList = this.iformDynamic.filter( item => {
        return item.status === 1
      }) 
      console.log(formList,iformList)
      let subRoomList = []
      let resultUpdate  = iformList.every( item => {
        subRoomList.push(this.$refs[`iform${item.index}`][0].formValidate())
        return this.$refs[`iform${item.index}`][0].formValidate()
      })
      let result = formList.every( item => {
        subRoomList.push(this.$refs[`form${item.index}`][0].formValidate())
        return this.$refs[`form${item.index}`][0].formValidate()
      })
      // console.log("result:"+result+",resultUpdate:"+resultUpdate)
      if(result && resultUpdate) {
       return subRoomList
      }else{
        return false
      }
    },
    save() {
      let data = null
      this.$refs['formValidate'].validate( bool => {
        if(bool){
          if(this.formData.houseRentType===0){

            if(!this.$refs.houseRentType0LongTermPrice.validateSubmit()) return;
            this.formData.discountPriceDtoList = this.$refs.houseRentType0LongTermPrice.submitDiscountPriceDtoList()

            updateHouse(this.formData).then(res => {
             this.$Message.success('修改房源成功');
              this.changeLoading()
              this.$emit('refresh')
              this.show=false
            })
          }else{ // 合租类型
            this.formData.subRoomList = this.validateSubRoomList()          
            if(!this.formData.subRoomList) return 
            updateHouse(this.formData).then(res => {
              this.$Message.success('修改房源成功');
              this.changeLoading()
              this.$emit('refresh')
              this.show=false
            })
          
          }
        }else{
          console.log('false')
       // this.changeLoading()
        return
        }
      });
    }
  }
  
}
</script>